// src/lib/proprio-messages-sort.js — tri/filtre de l'inbox proprio (LECTURE SEULE)
//
// Helpers PURS (aucune dépendance React/DOM) pour l'onglet Messages de l'espace
// proprio. Retour terrain (#2) : le tri par défaut « par logement » était
// contre-intuitif. Règle Dimitri : DÉFAUT = dernier message en haut
// (chronologique décroissant sur la date du dernier message du fil), + un
// FILTRE logement optionnel par-dessus qui ne change PAS le tri.
//
// Source de données / cloisonnement serveur inchangés : on ne fait QUE ré-ordonner
// et filtrer côté client ce que l'endpoint cloisonné a déjà renvoyé.

// Regroupe les messages voyageur par fil (thread_id, fallback résa puis msg) et
// trie « dernier message en haut » : lastAt décroissant. Un fil sans date
// exploitable (lastAt = 0) part en bas, de façon déterministe (tie-break stable
// sur thread_id) pour éviter tout ordre instable au re-render.
export function groupThreadsByLastMessage(messages) {
  const map = new Map()
  for (const m of messages || []) {
    const k = m.thread_id || (m.reservation_id ? `resa:${m.reservation_id}` : `msg:${m.id}`)
    if (!map.has(k)) map.set(k, { thread_id: k, messages: [], lastAt: 0 })
    const t = map.get(k)
    t.messages.push(m)
    const ts = new Date(m.created_at).getTime()
    if (Number.isFinite(ts) && ts > t.lastAt) t.lastAt = ts
  }
  // Messages d'un fil triés chrono ASC (le composant lit le dernier en queue).
  map.forEach((t) => t.messages.sort((a, b) => new Date(a.created_at) - new Date(b.created_at)))
  return Array.from(map.values()).sort(
    (a, b) => (b.lastAt - a.lastAt) || String(a.thread_id).localeCompare(String(b.thread_id)),
  )
}

// Filtre optionnel par logement, par-dessus le tri (n'altère PAS l'ordre des
// fils restants). « all » / vide = pas de filtre. `logIdOf(thread)` résout le
// logement d'un fil ; null/undefined → bucket '__unknown__'.
export function filterThreadsByLogement(threads, logFilter, logIdOf) {
  if (!logFilter || logFilter === 'all') return threads || []
  return (threads || []).filter((t) => {
    const id = logIdOf(t)
    return String(id == null ? '__unknown__' : id) === String(logFilter)
  })
}
